document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-ftd-mobile-buybar]');
  const productForm = document.querySelector('product-form form');
  const primaryButton = productForm?.querySelector('[type="submit"]');
  if (!bar || !productForm || !primaryButton) return;

  const barButton = bar.querySelector('button');
  const priceTarget = bar.querySelector('[data-ftd-price]');
  const priceSource = document.querySelector('[id^="price-"]');
  const sync = () => {
    barButton.disabled = primaryButton.disabled;
    barButton.textContent = primaryButton.querySelector('span')?.textContent?.trim() || primaryButton.textContent.trim();
    if (priceSource && priceTarget) priceTarget.textContent = priceSource.innerText.trim().split('\n')[0];
  };

  barButton.addEventListener('click', () => primaryButton.click());
  new MutationObserver(sync).observe(primaryButton, { attributes: true, childList: true, subtree: true });
  if (priceSource) new MutationObserver(sync).observe(priceSource, { childList: true, subtree: true });
  new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .1 }).observe(primaryButton);
  sync();
});
